export class FocusUtils {
  /**
   * Sets focus on the given HTML element if it is not disabled and has a valid tabindex.
   *
   * @param {HTMLElement} element - The HTML element to set focus on.
   * @param {boolean} disabled - A flag indicating whether the element is disabled.
   * @param {number} tabidx - The tabindex of the element.
   * @returns {boolean} - Returns true if the focus was successfully set, otherwise false.
   */
  static setFocus(
    element: HTMLElement,
    disabled: boolean,
    tabidx: number,
  ): boolean {
    if (disabled || tabidx == -1) {
      console.log(
        'Antiqua DLS: Focus is not allowed on disabled element or element with tabindex=-1',
      );
      return false;
    }
    if (element) {
      element.focus();
      return true;
    }
    return false;
  }

  static hasExplicitFocusMethod(element: HTMLElement | null): boolean {
    if (element && typeof (element as any).setFocus === 'function') {
      return true;
    }
    return false;
  }

  static canReceiveFocus = (element: HTMLElement): boolean => {
    const { disabled, tabIndex, tabidx, as } = element as any;
    if (disabled) {
      return false;
    }
    if (tabidx !== undefined) {
      if (tabidx == -1) {
        return false;
      } else {
        if (as !== undefined && as == 'icon') {
          return false;
        }
        return true;
      }
    } else {
      if (tabIndex === undefined || tabIndex === null) {
        return true;
      }
      if (tabIndex < 0) {
        return false;
      }
    }

    return true;
  };
}
